export const loadInitialRowsTitle = "lbimPe";
export const loadInitialRowsContentText = "dIrtv";
export const loadInitialRowsOfflineSettingsLinkText = "y9oMxc";
export default {loadInitialRowsTitle,loadInitialRowsContentText,loadInitialRowsOfflineSettingsLinkText};